import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import TitleBlock, { TitleDescription } from '../../TitleBlock';

const pricingSectionTitleMobile = media.phone`
  h1, h2, h3, h4, h5, h6 {
      font-size: 28px;
      line-height: 36px;
  }
`;

const pricingSectionDescriptionMobile = media.phone` 
   ${TitleDescription} {
    font-size: 16px;
    line-height: 25px;
  }
`;

const wrapperStyles = css`
  width: 100%;
  max-width: 1180px;
  padding: 0 20px;
`;

export const PricingSectionTopWrapper = styled.div`
  ${wrapperStyles};
  margin: 35px auto 0;
`;

export const PricingSectionBottomWrapper = styled.div`
  ${wrapperStyles};
  margin: 0 auto 70px;
`;

export const PricingSectionVideoSliderWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const PricingSectionTitleBlock = styled(TitleBlock)`
  margin: 0 auto 20px;
  text-align: center;
  ${pricingSectionTitleMobile};
  ${pricingSectionDescriptionMobile};
`;
